import { call, put } from 'redux-saga/effects';
import { getLastActiveDeclarations } from '../services/api';
import { getDeclarationsError, getDeclarationsSuccess } from '../redux/actions';

export function* getDeclarationsSaga() {
  const { isOk, error, data } = yield call(getLastActiveDeclarations);
  if (isOk) {
    return yield put(getDeclarationsSuccess(data));
  }
  return yield put(getDeclarationsError(error));
}
